import React, { useContext, useEffect, useState } from "react"
import { Dialog, DialogPanel } from "@headlessui/react"
import { CheckIcon } from "@phosphor-icons/react"
import clsx from "clsx"
import { countryCurrencies } from "@staticdata/currencies"
import { StoreContext } from "@context/StoreContext"
import { getCurrencySymbol } from "@utils/utils"

import "country-flag-icons/1x1/flags.css"
import SearchBar from "@components/common/SearchBar"

const CurrencySelectorModal = ({ isOpen = false, onClose = () => {} }) => {
	const { currencySelected, setCurrencySelected } = useContext(StoreContext)
	const [searchText, setSearchText] = useState("")
	const [filteredList, setFilteredList] = useState(countryCurrencies)

	const handleSearch = (e) => {
		e.preventDefault()
		setSearchText(e.target.value)
	}

	useEffect(() => {
		setSearchText("")
	}, [currencySelected])

	useEffect(() => {
		let filtered
		if (searchText.trim() === "") filtered = countryCurrencies
		else
			filtered = countryCurrencies.filter((item) =>
				item?.currencyCode?.toLowerCase().includes(searchText.toLowerCase()) ||
				item?.label?.toLowerCase().includes(searchText.toLowerCase())
			)
		setFilteredList(filtered)
	}, [searchText])

	const handleOnClose = () => {
		onClose()
	}

	return (
		<React.Fragment>
			<Dialog
				open={isOpen}
				onClose={handleOnClose}
				className="relative z-[100]"
			>
				<div className="fixed inset-0 w-screen overflow-y-auto p-4 bg-black/20">
					<div className="flex min-h-full items-center justify-center">
						<DialogPanel
							className={`relative border bg-white overflow-y-auto minimalist-scrollbar gap-6 shadow-lg rounded-md px-4 py-6 w-full max-w-[480px]`}
						>
							<div className="w-full flex flex-col gap-y-8">
								<div className="flex flex-col w-full space-y-3">
									<div className="text-xs text-[#D1D1D1]">
										<p className="text-center font-medium !text-sm pb-2 text-black">
											Choose a currency
										</p>
										<SearchBar
											value={searchText}
											onChange={handleSearch}
											placeHolder="SELECT CURRENCY"
											noBorders
										/>
									</div>
									<div className="overflow-y-scroll h-[56vh] md:max-h-96 minimalist-scrollbar">
										{filteredList?.map((item) => {
											return (
												<div
													className="cursor-pointer hover:bg-slate-50/75 px-3 py-2 text-sm"
													key={`dp-${item?.countryCode}`}
													onClick={() => {
														setCurrencySelected(item)
														handleOnClose()
													}}
												>
													<div className="flex gap-x-2 flex-nowrap ">
														<span
															className={clsx(
																`rounded-full text-lg`,
																`flag:${item?.countryCode}`
															)}
														/>
														<div className="flex-1 flex gap-2">
															<span className="text-primary font-medium uppercase">
																{item?.currencyCode}
															</span>
															<span className="ml-1 text-secondary capitalize">
																{item?.label}
															</span>
															{/* <span>{`${getCurrencySymbol(item.currencyCode)?.symbol}`}</span> */}
														</div>
														{currencySelected?.countryCode ===
															item?.countryCode && (
															<CheckIcon className="text-success" size={18} />
														)}
													</div>
												</div>
											)
										})}
									</div>
								</div>
							</div>
						</DialogPanel>
					</div>
				</div>
			</Dialog>
		</React.Fragment>
	)
}

export default CurrencySelectorModal